import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import Link from '@Navigation/Link';
import { useDeps } from '@Contexts/DI';
import ProductImage from '@Components/ProductImage';
import styles from './Preview.module.css';

import type { ProductData } from '@Types/Product';
import type { FC, HTMLAttributes } from 'react';

export interface PreviewProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  product?: ProductData;
  position?: number;
}

const Preview: FC<PreviewProps> = (props) => {
  const { className, product, position, ...restProps } = props;
  const images = product.images || [];
  const [firstImage] = images;
  const { analytics } = useDeps();

  const handleClick = useCallback(() => {
    analytics.dispatchEvent('card.click', {
      cardType: 'relatedProduct',
      listTitle: 'Сопутствующие товары карточка товара',
      id: product.id,
      card: product,
      position,
    });
  }, [position, product, analytics]);

  return (
    <div {...restProps} className={cn(styles.preview, className)}>
      <Link to={product.link} aria-label={product.name} target='_blank' onClick={handleClick}>
        <div className={styles.content}>
          <ProductImage className={styles.image} src={firstImage?.src} />
        </div>
      </Link>
    </div>
  );
};

export default memo(Preview);
